import Cookies from 'universal-cookie/es6';
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems3
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina Creación – Se defienen los botones de la barra de navegación.
13/10/2021 Cristian Andres Pizo Mina -  Se agrego /Overtime
================================================================================ */
export default function MenuItems9() {
    let history = useHistory();
    const cookies = new Cookies();
    const items = [
        {
            label: 'Nómina abierta',
            path: "/OpenPayroll",
            index: 0
        },
        {
            label: 'Nómina acumulados históricos',
            path: "/HistoricPayroll",
            index: 1
        },
        {
            label: 'Seguridad social',
            path: "/PILA",
            index: 2
        },
        {
            label: 'Contabilidad',
            path: "/HistoricAccounting",
            index: 3
        },
        {
            label: 'Nómina electrónica',
            path: "/HistoricElectronicPayroll",
            index: 4
        }

    ];
    return items
}